import {AxiosRequestConfig} from 'axios';
import {DEFAULT_RETRY_CONFIG} from 'common/constants';
import {
  API_USER_GET_PROFILE,
  API_USER_UPDATE_PROFILE,
} from 'common/constants/apis';
import {CRASHLYTICS_PROFILE_ERROR} from 'common/constants/errors';

import {
  UserProfileResp,
  UserUpdateProfileResp,
} from 'common/interfaces/iprofile';
import {IUser} from 'common/interfaces/iuser';
import UILogger, {LogRecordType, LogSeverityType} from 'common/utils/logger';
import httpClient from './config';

export namespace ProfileService {
  export const postUserProfileUpdate = async (
    profile: IUser,
  ): Promise<UserUpdateProfileResp> => {
    UILogger.log('Updating User Profile: ', profile);

    return httpClient
      .put(API_USER_UPDATE_PROFILE, profile)
      .then(resp => {
        UILogger.log('postUserProfileUpdate response: ', resp.data);
        return resp.data;
      })
      .catch(errorResp => {
        UILogger.log('postUserProfileUpdate error reponse: ', errorResp);
        return errorResp;
      });
  };

  export const fetchUserProfileData = (
    updateAppData?: boolean,
    refreshCache?: boolean,
  ): Promise<UserProfileResp> => {
    UILogger.log('Getting User Profile Data>>>');
    const reqTime = Date.now();
    return httpClient
      .get(API_USER_GET_PROFILE, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
      .then(resp => {
        console.log('fetchUserProfileData response: ', resp.data);
        return resp.data;
      })
      .catch(error => {
        // UILogger.error('Error in getting User profile and Stats', error);
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_PROFILE_ERROR,
          },
          'Error in getting User profile and Stats',
        );
        return {
          status: {success: false},
        };
      });
  };
}
